import React, { useEffect } from 'react';
import '../../css/home/Trending.scss'
import { useSpotify } from '../../contexts/SpotifyProvider'
import { Canvas } from '@react-three/fiber';
import * as THREE from 'three'
import HomeScene from '../threejs/src/HomeScene'

export default function Trending() {
  const { newReleases, getNewReleases, loading, setGoBack } = useSpotify()

  useEffect(() => {
    try {
      getNewReleases()

      setGoBack(false)
    } catch (error) {
      console.error(error)
    }
  }, [getNewReleases])

  return (
    <>
      {loading ? (
        <div className="trending">
          <h2 className='trendingTitle'>Trending</h2>
          <div className="trendingReleases">
            <div className="loading">
              <p>Loading...</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="trending">
          <h2 className='trendingTitle'>Trending</h2>
          <div className="trendingReleases">
            <Canvas
              gl={{
                antialias: true,
                toneMapping: THREE.ACESFilmicToneMapping,
                outputEncoding: THREE.sRGBEncoding
              }}
              camera={{ position: [0, 0, 250] }}
              className='canvas'
            >
              <HomeScene releases={newReleases?.albums?.items}/>
            </Canvas>
          </div>
        </div>
      )}
    </>
  )
}